import React, { useContext } from "react";
import styled from "styled-components";

import AssetDownloadContext from "core/AssetDownload/Context";

import colors from "core/colors";
import CrownIcon from "core/ReusableIcons/Crown";

import useFeatureFlag from "frontend/hooks/useFeatureFlag";
import { PREMIUM_PHOTOS_FLAG } from "frontend/data/featureFlags";

const Heading = styled.h1`
    font-size: 1.375rem; /* 22px */
    line-height: 1.249375;
    margin-bottom: 1rem; /* 16px */
    color: ${colors.primary.diamond};
`;

const HeadingTextWrapper = styled.span`
    margin-right: 0.5rem; /* 8px */
`;

const PremiumBadge = styled.span`
    display: inline-flex;
    font-size: 0.8125rem; /* 13px */
    gap: 0.25rem;
    color: ${colors.secondary.sunshine};
    padding: 0.25rem 0;

    span {
        padding-top: 0.125rem; /* 2px */
    }
`;

const Header = () => {
    const { state } = useContext(AssetDownloadContext);
    const hasPremiumPhotos = useFeatureFlag(PREMIUM_PHOTOS_FLAG);

    const {
        asset: { title, isPremium }
    } = state;

    const showPremiumBadge = hasPremiumPhotos && isPremium;

    return (
        <header>
            <Heading>
                <HeadingTextWrapper>{title}</HeadingTextWrapper>{" "}
                {showPremiumBadge && (
                    <PremiumBadge>
                        <CrownIcon size="sm" />
                        <span>Premium</span>
                    </PremiumBadge>
                )}
            </Heading>
        </header>
    );
};

export default Header;
